module.exports = __webpack_public_path__ + "static/img/twjd-sde6-1.c9dc97d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sde6-1.png
// module id = 842
// module chunks = 0